import DashboardIcon from '@/assets/assets-slide-dashboard.svg';

export default [

];
